export type JSide = "left" | "right";

export interface Question {
  id: number;
  scene: string;
  left: string;
  right: string;
  jSide: JSide;
}

export const QUESTIONS: readonly Question[] = [
  {
    id: 1,
    scene: "想到这个周末怎么过时",
    left: "我通常会提前排个大概",
    right: "我更愿意当天看心情决定",
    jSide: "left",
  },
  {
    id: 2,
    scene: "去一个没去过的城市旅行",
    left: "只订必要的，其他边走边看",
    right: "住宿、路线和重点行程先确认",
    jSide: "right",
  },
  {
    id: 3,
    scene: "群里约一次聚会",
    left: "时间地点早点定下来更轻松",
    right: "临近时再根据大家情况调整",
    jSide: "left",
  },
  {
    id: 4,
    scene: "临时邀约打乱了原计划",
    left: "重新安排一下，加入也不错",
    right: "除非很重要，否则保留原计划",
    jSide: "right",
  },
  {
    id: 5,
    scene: "面对一个周期较长的任务",
    left: "我会拆成阶段，早点推进",
    right: "我常在临近期限时集中进入状态",
    jSide: "left",
  },
  {
    id: 6,
    scene: "手上有事没做完但有点累",
    left: "先换件更有感觉的事也可以",
    right: "收好尾再休息会更踏实",
    jSide: "right",
  },
  {
    id: 7,
    scene: "购买需要比较的东西",
    left: "定好标准后选一个就结束",
    right: "多看看，也许后面有更合适的",
    jSide: "left",
  },
  {
    id: 8,
    scene: "刚开始一个新项目",
    left: "先动起来，再根据反馈调整",
    right: "先把结构和步骤想清楚再开始",
    jSide: "right",
  },
  {
    id: 9,
    scene: "收到一场活动的邀请",
    left: "时间地点等细节明确才安心",
    right: "知道大概方向就够了",
    jSide: "left",
  },
  {
    id: 10,
    scene: "日常整理桌面或文件",
    left: "找得到就好，放法可以灵活",
    right: "我喜欢有固定位置和规则",
    jSide: "right",
  },
  {
    id: 11,
    scene: "和朋友外出吃饭",
    left: "出发前大致选好去哪家",
    right: "到附近再看哪家更想吃",
    jSide: "left",
  },
  {
    id: 12,
    scene: "已经决定的事情突然有变化",
    left: "新变化有时会带来新鲜感",
    right: "我更希望按已经说好的进行",
    jSide: "right",
  },
  {
    id: 13,
    scene: "去一个有明确开始时间的地方",
    left: "我会预估路程并留出余量",
    right: "准备好就出门，路上再调整",
    jSide: "left",
  },
  {
    id: 14,
    scene: "几个选项看起来都不错",
    left: "先保留，等更多信息再说",
    right: "做出选择后，脑子会轻松很多",
    jSide: "right",
  },
  {
    id: 15,
    scene: "一天有好几件事要完成",
    left: "我会排好顺序逐项划掉",
    right: "我会按当下状态选择先做什么",
    jSide: "left",
  },
  {
    id: 16,
    scene: "一次聚会快结束时",
    left: "下次想见再临时约也很好",
    right: "我倾向顺手把下一次时间定下",
    jSide: "right",
  },
] as const;

export const CHOICE_LABELS = [
  "完全像左边",
  "比较像左边",
  "都可以",
  "比较像右边",
  "完全像右边",
] as const;
